if (!customElements.get('coming-soon-form')) {
  class ComingSoonForm extends HTMLElement {
    constructor() {
      super();
      /** @type {HTMLFormElement} */
      // @ts-expect-error
      this.form = this.querySelector('form');
    }

    connectedCallback() {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    /**
     * @param {Event} e
     */
    onSubmit(e) {
      e.preventDefault();

      if (this.getAttribute('state') === 'submitting') {
        return;
      }

      this.setAttribute('state', 'submitting');

      /** @type {HTMLInputElement} */
      // @ts-expect-error
      const emailInput = this.querySelector('input[name="email"]');

      /** @type {HTMLInputElement} */
      // @ts-expect-error
      const optinInput = this.querySelector('input[name="optin"]');

      /** @type {string} */
      const productId = this.getAttribute('data-product-id') || '';

      const fields = {
        $source: 'PDP',
        'Accepts Marketing': optinInput.checked,
        [`coming_soon_product_${productId}`]: true,
      };

      const data = {
        g: this.getAttribute('data-list-id'),
        email: emailInput.value.trim(),
        $fields: Object.keys(fields),
        ...fields,
      };

      this.addToList(data).then(() => {
        this.setAttribute('state', 'submitted');
      });
    }

    /**
     * @param {Object} data
     */
    async addToList(data) {
      const options = {
        method: 'POST',
        headers: {
          'cache-control': 'no-cache',
          'content-type': 'application/x-www-form-urlencoded',
        },
        body: this.serializeData(data),
      };

      const subscribeUrl =
        'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

      await fetch(subscribeUrl, options);
      return true;
    }

    /**
     * @param {Record<string, any>} data
     * @returns {string}
     */
    serializeData(data) {
      const formData = [];
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          const value = data[key];
          formData.push(`${key}=${encodeURIComponent(value)}`);
        }
      }
      return formData.join('&');
    }
  }

  customElements.define('coming-soon-form', ComingSoonForm);
}
